import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { MutableRefObject, useEffect } from 'react';
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormInput from "@form/FormInput";
import { Button } from "@ui";

interface Props {
    name: string;
    // Optional ref that external callers use to append exceptions without being inside the RHF context
    appendRef?: MutableRefObject<((value: { start: string; end: string }) => void) | null>;
}

// Field array for managing recurring-allocation exceptions (date-range pairs)
const ExceptionsFieldArray = ({ name, appendRef }: Props) => {
    const { t } = useTranslation('space-manager');
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({ control, name });

    // Expose append to callers outside the FormProvider via the ref
    useEffect(() => {
        if (appendRef) appendRef.current = append;
    }, [append, appendRef]);

    return <div className="tw-mt-4">
        <label className="tw-text-accents-9 tw-pl-1" htmlFor={name}>{t('allocation.exceptions.label')}</label>
        <div className="tw-flex tw-flex-col tw-gap-2">
            {fields.map((field, index) => <div key={field.id} className="tw-flex tw-gap-4">
                <div className="tw-flex-1">
                    <FormInput.DatePicker name={`${name}.${index}.start`}
                        labelLeft={t('allocation.exceptions.from')}
                    />
                </div>
                <div className=" tw-flex-1">
                    <FormInput.DatePicker name={`${name}.${index}.end`}
                        labelLeft={t('allocation.exceptions.until')}
                    />
                </div>
                <div className="tw-flex tw-justify-center tw-items-center">
                    <button type="button" className="tw-button-clean" onClick={() => remove(index)}>
                        <FontAwesomeIcon icon={faTrash} className="tw-text-accents-6" />
                    </button>
                </div>
            </div>)}
            <Button size="xs" auto color="light" block icon={<FontAwesomeIcon icon={faPlus} />}
                onPress={() => append({})}
            >{t('allocation.exceptions.add')}</Button>
        </div>
    </div>;
};

export default ExceptionsFieldArray;
